import { Box } from '@mui/material'
import { styled } from '@mui/system'
import SearchIcon from '@mui/icons-material/Search'

export const StyledHeading = styled(Box)``
export const StyledSearchIcon = styled(SearchIcon)`
    margin: 0 10px 0 0;
`
